@if (profileLink(); as link) {
	<a [routerLink]="link" class="text-decoration-none w-100" aria-label="View my Member Profile">
		<ng-container *ngTemplateOutlet="cardContent" />
	</a>
} @else {
	<ng-container *ngTemplateOutlet="cardContent" />
}

<ng-template #cardContent>
	<div class="card h-100 member-profile-card" [class.member-profile-card-clickable]="!!profileLink()"
		[class.placeholder-glow]="isLoading()">
		<div class="card-body d-flex align-items-center gap-3 p-3 p-md-4">
			<!-- isSelectable=false: nothing listens to (clicked) here, so the avatar must not offer a
			     pointer cursor or a "Select {name}" checkbox for an action it cannot do. -->
			<ms-avatar [identity]="member()" [avatarSize]="avatarSize" [avatarShape]="avatarShape"
				[avatarAdditionalAttributes]="avatarAdditionalAttributes"
				[isLoading]="isLoading()" [showUploadControls]="false" [isSelectable]="false" />

			<div class="flex-grow-1 min-w-0">
				@if (isLoading()) {
					<span class="placeholder col-6 placeholder-lg mb-1 d-block"></span>
					<span class="placeholder col-8 placeholder-sm d-block"></span>
				} @else {
					<h5 class="member-profile-name mb-0 fw-bold text-truncate" [msTooltip]="fullName()" msTooltipOnlyIfTruncated>
						{{ fullName() }}
					</h5>

					@if (member()?.emailAddress) {
						<div class="d-flex ms-icon-text gap-2 text-muted small min-w-0 mt-1">
							<fa-duotone-icon icon="envelope" secondaryOpacity="0.4" />
							<span class="member-profile-email text-truncate min-w-0" [msTooltip]="member()?.emailAddress ?? ''"
								msTooltipOnlyIfTruncated>{{ member()?.emailAddress }}</span>
						</div>
					}

					@if (phoneLine()) {
						<div class="d-flex ms-icon-text gap-2 text-muted small min-w-0 mt-1">
							<fa-duotone-icon icon="phone" secondaryOpacity="0.4" />
							<span class="member-profile-phone text-truncate min-w-0" [msTooltip]="phoneLine()"
								msTooltipOnlyIfTruncated>{{ phoneLine() }}</span>
						</div>
					}
				}
			</div>

			@if (profileLink()) {
				<fa-duotone-icon icon="arrow-right" class="member-profile-chevron text-muted" secondaryOpacity="0.9" />
			}
		</div>
	</div>
</ng-template>
